import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { QueryClientProvider } from '@tanstack/react-query';

import '@fontsource/noto-sans-tc/chinese-traditional.css';
import 'react-toastify/dist/ReactToastify.css';
import '#/modules/infra/css/index.css';

import { applyBrand } from '#/config/brand';
import { initTheme } from '#/hooks/useTheme';
import store from '#/modules/infra/configureStore';
import queryClient from '#/modules/infra/queryClient';
import Toastify from '#/modules/infra/components/Toastify';
import App from '#/modules/infra/App';

applyBrand();
initTheme();

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <Toastify />
      <App />
    </QueryClientProvider>
  </Provider>,
);
